<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="活动名称：" name="activity_name"></c-form-item>
<!--                    <c-form-item type="datetime" label="活动时间：" start-name="begin_date" end-name="end_date"></c-form-item>-->
                    <c-form-item type="checkbox" label="状态：" name="states" :options="stateOptions"></c-form-item>
                    <c-form-item type="checkbox" label="可售范围：" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_recharge_bonus_edit" color="sys" @click="navigateTo('/recharge_bonus_add')">新建储值送活动</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column label="状态" name="state" width="100">
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="活动名称" name="activity_name" width="200"></c-table-column>
                <c-table-column
                        label="可售范围"
                        width="90"
                        name="visible_user_level_name"
                >
                    <template #default="{data}">
                        <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部会员'" style="color:blue">全部会员</span>
                        <span v-else-if="data.visible_user_level_name" v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                        <span v-else></span>
                    </template>
                </c-table-column>
                <c-table-column label="活动时间" name="begin_date" width="290">
                    <template v-slot="{data}">
                        {{data.begin_date}} ~ {{data.end_date}}
                    </template>
                </c-table-column>
                <c-table-column label="充值金额" name="recharge_amount" width="120">
                    <template v-slot="{data}">￥{{ parseFloat(data.recharge_amount).toFixed(2) }}</template>
                </c-table-column>
                <c-table-column label="创建人" name="create_user" width="160"></c-table-column>
                <c-table-column label="创建时间" name="create_date" width="160"></c-table-column>
                <c-table-column label="更新人" name="update_user" width="160"></c-table-column>
                <c-table-column label="更新时间" name="update_date" width="160"></c-table-column>
                <c-table-column type="button" fixed="right" label="操作" width="160">
                    <template v-slot="row">
                        <c-table-button @click="navigateTo(`/recharge_bonus_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.state == 1 && row.data.start_state != 2" power="b_recharge_bonus_edit" @click="navigateTo(`/recharge_bonus_edit/${row.data.id}`)">编辑</c-table-button>
                        <c-table-button v-if="row.data.start_state != 2" power="b_recharge_bonus_state" @click="changeState(row)">{{ row.data.state === 1 ? '启用' : '停用' }}</c-table-button>
                        <c-table-button v-if="row.data.state == 1 || row.data.start_state == 2" power="b_recharge_bonus_edit" @click="removeBundle(row)">删除</c-table-button>
<!--                        <c-table-button @click="saleAnalysis(row)">套餐销售情况</c-table-button>-->
                    </template>
                </c-table-column>
            </c-table>
            <c-dialog ref="saleAnalysisDialog"
                :title="saleRechargeDialogTitle"
                width="1000"
                height="auto"
                :button="true"
                :close-button="true"
                >
                <m-search ref="searchSaleAnalysis" @search="searchSaleAnalysisHandle">
                    <c-form>
                        <c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>

                <c-table ref="salesAnalysisTable" style="height:600px">
                    <c-table-column label="昵称" name="nick_name" width="100">
                    </c-table-column>
                    <c-table-column label="手机号" name="user_manage_mobilephone" width="100">
                    </c-table-column>
                    <c-table-column label="下单时间" name="create_date" width="120"></c-table-column>
                    <c-table-column label="下单商品数量" name="product_count" width="100"></c-table-column>
                    <c-table-column label="下单商品金额" name="product_money" width="120">
                        <template v-slot="{data}">￥{{ parseFloat(data.product_money).toFixed(2) }}</template>
                    </c-table-column>
                    <c-table-column label="订单号" name="order_number" width="120">
                        <template v-slot="{data}">
                            <p>{{data.order_number}}</p>
                            <p style="margin-top: 2px;" ><a @click="navigateTo(`/order_detail/${data.order_number}`)" power="b_order_detail" style="color: blue">订单详情</a></p>
                        </template>
                    </c-table-column>
                </c-table>
            </c-dialog>

        </module>
    </page>
</template>

<script>
export default {
    name: 'm_recharge_bonus',

    data() {
        return {
            stateOptions: [
                { name: '未开始', value: 0 },
                { name: '进行中', value: 1 },
                { name: '已结束', value: 2 },
                { name: '暂停中', value: 3 }
            ],
            selectId:0,
            saleRechargeDialogTitle:'',
            userLevelOptions: []
        };
    },

    mounted() {
        this.initUserLevelOptions();
        this.$refs.search.search();
        this.$bus.$on('m_recharge_bonus.update', () => {
            this.$refs.search.search();
        });
    },

    computed: {
        activityStateText() {
            var state = {};
            this.stateOptions.forEach(item => {
                state[item.value] = item.name;
            });

            return state;
        }
    },

    beforeDestroy() {
        // 组件销毁前移除事件监听器
        this.$bus.$off('m_recharge_bonus.update');
    },

    methods: {
        //加载会员等级列表
        initUserLevelOptions(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                }
            });
        },
        searchHandle(data) {
            this.$refs.table.load({
                url: '/recharge_bonus/list',
                data
            });
        },

        changeState(row) {
            const newState = row.data.state === 1 ? 2 : 1;
            const action = newState === 2 ? '启用' : '禁用';

            this.$confirm({
                text: `确定要${action}此储值送活动吗？`,
                resolve: () => {
                    this.request({
                        url: '/recharge_bonus/updateState',
                        data: {
                            id: row.data.id,
                            state: newState
                        },
                        loading: true,
                        success: () => {
                            this.$message({ text: `${action}成功` });
                            this.$refs.table.update();
                        },
                        fail: (code, data, msg) => {
                            this.$confirm({
                                text: msg,  // 提示内容,
                                buttonName: '知道了',  // 确定按钮文字
                                cancelButton: false  // 是否显示取消按钮
                            });
                            return false;
                        }
                    });
                }
            });
        },
        removeBundle(row) {
            this.$confirm({
                text: '确定要删除此储值送活动吗？',
                resolve: () => {
                    this.request({
                        url: '/recharge_bonus/delete',
                        data: {
                            id: row.data.id
                        },
                        loading: true,
                        success: () => {
                            this.$message({ text: '删除成功' });
                            this.$refs.table.update();
                        }
                    });
                }
            })
        },
        saleAnalysis(row) {
            this.selectId = row.data.id;
            this.saleRechargeDialogTitle = '储值送活动【'+row.data.bundle_name+'】销售情况';
            this.$refs.searchSaleAnalysis.search();
            this.$refs.saleAnalysisDialog.open();
        },
        searchSaleAnalysisHandle(data){
            this.$refs.salesAnalysisTable.load({
                url: '/statistic/activity/orderSaleAnalysis',
                data: {
                    activity_id: this.selectId,
                    activity_type:8,
                    ...data
                }
            });
        }

    }
};
</script>
